import { Helmet } from "react-helmet";

export default function Terms() {
    return (
        <>
            <Helmet>
                <title>Terms & Conditions | WebUtility.online</title>
                <meta
                    name="description"
                    content="Review the Terms & Conditions for using WebUtility.online, including disclaimers, user responsibilities, and legal guidelines."
                />
                <link rel="canonical" href="https://webutility.online/terms" />
            </Helmet>

            <section className="p-8 max-w-screen-2xl bg-white rounded-xl shadow-lg mb-4 mx-auto text-center">
                <div className="container mx-auto">
                    <h1 className="text-3xl font-bold mb-2">Terms & Conditions</h1>
                    <p className="mb-4">Last Updated: 2025</p>

                    <p className="mb-4">
                        Welcome to <strong>WebUtility.online</strong>. By accessing or using our website, you agree to comply with and be bound by these Terms and Conditions.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Website</h2>
                    <p className="mb-4">
                        You agree to use the website only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the site.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">2. Intellectual Property</h2>
                    <p className="mb-4">
                        All content on this site, including text, graphics, logos, and software, is the property of WebUtility.online and protected by applicable copyright laws.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">3. Disclaimer</h2>
                    <p className="mb-4">
                        All tools and services are provided "as is" without warranties of any kind. We do not guarantee the accuracy or reliability of the outputs.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">4. Limitation of Liability</h2>
                    <p className="mb-4">
                        WebUtility.online shall not be liable for any indirect, incidental, or consequential damages arising from the use or inability to use the website.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">5. Modifications</h2>
                    <p className="mb-4">
                        We reserve the right to change these terms at any time. Continued use of the site implies acceptance of the updated terms.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-2">6. Contact</h2>
                    <p>
                        If you have any questions regarding these Terms & Conditions, contact us at{" "}
                        <a href="mailto:Rp7098979@gmail.com" className="text-blue-600 underline">Rp7098979@gmail.com</a>.
                    </p>
                </div>
            </section>
        </>
    );
}
